export default __webpack_public_path__ + "static/media/dianoiva_10.72b318fb.jpg";